import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const StyledContributors = styled(Type)`
  font-size: ${({ theme }) => theme.font.size.md};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.font.size.xs};
  }
`;

export const StyledEndorsement = styled(Type)`
  display: flex;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const StyledEndorsementLogo = styled.img`
  flex: 1;
  max-width: 5rem;
  margin-right: ${({ theme }) => theme.space.sm};
`;
